import React from 'react';
import './ErrorBanner.scss';
import PropTypes from 'prop-types';

export const ErrorBanner = (props) => {
  const { title } = props;
  return (
    <>
      <div className="message-container">
        {title}
      </div>
    </>
  );
};
ErrorBanner.propTypes = {
  title: PropTypes.string,
};
